module.exports = __webpack_public_path__ + "static/media/linkedin.1247d04e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/social/linkedin.svg
// module id = 29
// module chunks = 0